const programDetails = {
  "lop-trai-nghiem": {
    title: "LỚP TRẢI NGHIỆM",
    subtitle: "Khơi dậy đam mê mỹ thuật cho bé từ 3,5 đến 6 tuổi",
    description:
      "Lớp trải nghiệm dành cho các bé từ 3,5 đến 6 tuổi giúp trẻ làm quen với mỹ thuật, phát triển tư duy sáng tạo và kỹ năng quan sát thông qua các hoạt động vui chơi, học vẽ cơ bản.",
    objectives: [
      "Phát triển khả năng nhận thức màu sắc và hình khối.",
      "Khuyến khích tư duy sáng tạo và khám phá nghệ thuật.",
      "Giúp trẻ tăng cường kỹ năng phối hợp tay – mắt.",
    ],
    audience: "Trẻ em từ 3,5 đến 6 tuổi chưa có kinh nghiệm học mỹ thuật.",
    duration: "12 tuần (2 buổi/tuần)",
    fee: "3.500.000 VND/khóa",
    images: [
      "/images/art/programs/details/detail-experience1.webp",
      "/images/art/programs/details/detail-experience2.webp",
    ],
  },

  "chuong-trinh-can-ban-kid": {
    title: "CHƯƠNG TRÌNH CĂN BẢN (KID)",
    subtitle: "Nền tảng vững chắc cho học viên từ 7 đến 10 tuổi",
    description:
      "Chương trình căn bản tập trung vào kỹ thuật vẽ và phối màu, giúp học viên xây dựng nền tảng mỹ thuật ứng dụng thông qua thực hành đa dạng.",
    objectives: [
      "Nắm vững kỹ thuật vẽ cơ bản: chì, màu nước, màu acrylic.",
      "Hiểu và áp dụng phối màu trong tác phẩm.",
      "Phát triển tư duy sáng tạo và khả năng thể hiện ý tưởng.",
    ],
    audience: "Học viên từ 7 đến 10 tuổi có mong muốn học mỹ thuật bài bản.",
    duration: "16 tuần (2 buổi/tuần)",
    fee: "5.000.000 VND/khóa",
    images: [
      "/images/art/programs/details/detail-basic1.webp",
      "/images/art/programs/details/detail-basic2.webp",
    ],
  },

  "chuong-trinh-nang-cao-top": {
    title: "CHƯƠNG TRÌNH NÂNG CAO (TOP)",
    subtitle: "Phát triển kỹ năng chuyên sâu cho học viên từ 11 đến 16 tuổi",
    description:
      "Tập trung đào tạo kỹ năng chuyên sâu, sáng tạo và ứng dụng mỹ thuật trong thực tế, chuẩn bị cho các kỳ thi năng khiếu và phát triển nghề nghiệp tương lai.",
    objectives: [
      "Nâng cao kỹ thuật vẽ và phối cảnh.",
      "Rèn luyện kỹ năng sáng tạo và thể hiện ý tưởng độc đáo.",
      "Chuẩn bị thi năng khiếu và định hướng nghề nghiệp mỹ thuật.",
    ],
    audience: "Học viên từ 11 đến 16 tuổi đã có nền tảng mỹ thuật căn bản.",
    duration: "20 tuần (3 buổi/tuần)",
    fee: "7.000.000 VND/khóa",
    images: [
      "/images/art/programs/details/detail-advanced1.webp",
      "/images/art/programs/details/detail-advanced2.webp",
    ],
  },

  "chuong-trinh-my-thuat-ung-dung": {
    title: "CHƯƠNG TRÌNH MỸ THUẬT ỨNG DỤNG",
    subtitle: "Áp dụng mỹ thuật vào thiết kế, thời trang và quảng cáo",
    description:
      "Chương trình dành cho học viên muốn học cách áp dụng nghệ thuật vào các lĩnh vực sáng tạo như thiết kế đồ họa, thời trang, quảng cáo,...",
    objectives: [
      "Hiểu rõ mỹ thuật ứng dụng và các lĩnh vực liên quan.",
      "Thực hành các dự án thiết kế sáng tạo.",
      "Phát triển tư duy thiết kế và kỹ năng trình bày ý tưởng.",
    ],
    audience: "Học viên từ 12 tuổi trở lên quan tâm đến mỹ thuật ứng dụng.",
    duration: "18 tuần (2 buổi/tuần)",
    fee: "6.000.000 VND/khóa",
    images: [
      "/images/art/programs/details/detail-applied1.webp",
      "/images/art/programs/details/detail-applied2.webp",
    ],
  },
};

export default programDetails;
